import React from 'react';
import Button from '~/components/atoms/button/button';
import ShoppingCartIcon from '~/components/atoms/icon/shoppingCart/shoppingCartIcon';
import { useProductContext } from '~/components/organisms/products/productSingleResult/productResultContext';
import { usePlugin } from '~/plugins/pluginContext';

const AddToCartButton: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { doAction } = usePlugin();
    const { fullResult: result, style } = useProductContext();

    const handleClick = () => {
        doAction('addToCart', { result });
    };

    const handleMouseDown = (event: { preventDefault: () => void; stopPropagation: () => void }) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleKeyDown = (event: { preventDefault: () => void; stopPropagation: () => void }) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <Button
            className={style.addToCartButton}
            onclick={handleClick}
            onMouseDown={handleMouseDown}
            onKeyDown={handleKeyDown}
            data-testid="instantsearch-module-addtocartbutton"
        >
            <ShoppingCartIcon width={24} height={24} />
            <span>{children}</span>
        </Button>
    );
};

export default AddToCartButton;
